import React from 'react';
import {SelectField, SelectInput} from 'react-admin';

const choices = [
    {id: 'DRAFT', name: 'cancelRequestStatus.DRAFT'},
    {id: 'IN_REVIEW', name: 'cancelRequestStatus.IN_REVIEW'},
    {id: 'ACCEPTED', name: 'cancelRequestStatus.ACCEPTED'},
    {id: 'REJECTED', name: 'cancelRequestStatus.REJECTED'},
]

export const CancelRequestStatusField = (props) => (
    <SelectField source={props.source} choices={choices} {...props} />
)

export const CancelRequestStatusInput = (props) => (
    <SelectInput source={props.source} choices={choices} {...props} />
)
const choices2 = [
    {id: 'IN_REVIEW', name: 'cancelRequestStatus.IN_REVIEW'},
    {id: 'ACCEPTED', name: 'cancelRequestStatus.ACCEPTED'},
    {id: 'REJECTED', name: 'cancelRequestStatus.REJECTED'},
]
export const AuthorizeCancelRequestStatusInput = (props) => (
    <SelectInput source={props.source} choices={choices2} {...props} />
)
